import EncryptUtility from "../../utility/js/encrypt-utility";
import Utility from "../../../shared/utility";
import reportService from "./reports-service";
import moment from "moment";
export default {
  props: {
    popupData: Array,
  },
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      customerData: [],
      partData: [],
      workCenterData: [],
      warehouseData: [],
      binData: [],
      issueData: [],
      pickTicketData: [],
      btoPartData: [],
      vendorData: [],
    };
  },
  methods: {
    //Get waybill params
    async getParamsWaybill(queryString) {
      const regex = /@sl_code='([^']+)'.*@waybill='([^']+)'/;
      const match = queryString.match(regex);
      let data = await reportService.assetHistoryWaybillLink("get", match[1], match[2]);
      if (data !== undefined) {
        if (data.message !== "NA") {
          const regex = /href="([^"]+)"/;
          const match = data[0].urlstring.match(regex);
          window.open(match[1], "_blank");
        }
      }
    },
    //Get Notes section
    async showNotes(queryString, trackId) {
      const regex = /@pass=(\d+),@query_id=(\d+)/;
      const match = queryString.match(regex);
      let data = await reportService.assetHistoryNoteQuery("get", match[1], match[2]);
      if (data !== undefined) {
        if (data.message !== "NA") {
          this.popupData.forEach((obj) => {
            if (obj.track_id === trackId) {
              obj.notes = data[0].query_val;
            }
          });
        }
      }
    },
    //Caption Details
    async captionDetails(item) {
      item.showDetails = !item.showDetails;
      const match = item.drill_query.match(/@([^=]+)=([^@]+)/);
      const spname = item.drill_query.match(/exec\s+(\w+\.\w+)\s+(.+)/);
      if (match[1] == "po_id") {
        item.showVendor = !item.showVendor;
        let data = await reportService.assetHistoryVendor("get", match[2]);
        if (data !== undefined) {
          if (data.message !== "NA") {
            this.vendorData = data;
          }
        }
      } else if (match[1] == "so_id") {
        item.showCustomer = !item.showCustomer;
        let data = await reportService.assetHistoryCustomer("get", match[2]);
        if (data !== undefined) {
          if (data.message !== "NA") {
            this.customerData = data;
          }
        }
      } else if (match[1] == "part_id") {
        item.showPart = !item.showPart;
        let data = await reportService.assetHistoryPart("get", match[2]);
        if (data !== undefined) {
          if (data.message !== "NA") {
            this.partData = data;
          }
        }
      } else if (match[1] == "loc") {
        item.showWorkCenter = !item.showWorkCenter;
        let data = await reportService.assetHistoryWorkCenter("get", match[2]);
        if (data !== undefined) {
          if (data.message !== "NA") {
            this.workCenterData = data;
          }
        }
      } else if (match[1] == "ware_id") {
        item.showWarehouse = !item.showWarehouse;
        let data = await reportService.assetHistoryWarehouse("get", match[2]);
        if (data !== undefined) {
          if (data.message !== "NA") {
            this.warehouseData = data;
          }
        }
      } else if (match[1] == "bin_id") {
        item.showBin = !item.showBin;
        let data = await reportService.assetHistoryBin("get", match[2]);
        if (data !== undefined) {
          if (data.message !== "NA") {
            this.binData = data;
          }
        }
      } else if (match[1] == "wip_id") {
        if (spname[1].substring(4) == "usp_Rx_RT_asset_history_drill_issues") {
          item.showIssues = !item.showIssues;
          let data = await reportService.assetHistoryDrillIssues("get", match[2]);
          if (data !== undefined) {
            if (data.message !== "NA") {
              this.issueData = data;
            }
          }
        } else if (spname[1].substring(4) == "usp_Rx_RT_asset_history_drill_PT") {
          item.showPickTicket = !item.showPickTicket;
          let data = await reportService.assetHistoryDrillPickTicket("get", match[2]);
          if (data !== undefined) {
            if (data.message !== "NA") {
              this.pickTicketData = data;
            }
          }
        }
      } else if (match[1] == "kit_id") {
        item.showBTOParts = !item.showBTOParts;
        let data = await reportService.assetHistoryDrillBTOParts("get", match[2]);
        if (data !== undefined) {
          if (data.message !== "NA") {
            this.btoPartData = data;
          }
        }
      }
    },
    //Remove Caption Details
    removeCaptionDetails(item) {
      item.details = [];
      item.showDetails = false;
      item.showVendor = false;
      item.showCustomer = false;
      item.showPart = false;
      item.showWorkCenter = false;
      item.showWarehouse = false;
      item.showBin = false;
      item.showIssues = false;
      item.showPickTicket = false;
      item.showBTOParts = false;
    },
    //Part number format function
    formatCreatedDate(text) {
      let parts = text.split(" , ");
      let date = parts[0].replace("Created:", "").trim();
      let name = parts[1].trim();
      date = Utility.displayDateFormat(date);
      date = moment(date).format("MM/DD/YYYY");
      return `Created: ${date} By: ${name}`;
    },
  },
};
